// extracted by mini-css-extract-plugin
var _1 = "PreviewShell_disableClicks__68245";
var _2 = "PreviewShell_highlighter__25e20";
var _3 = "PreviewShell_noClick__4e3b8";
var _4 = "PreviewShell_overlay__072cd";
var _5 = "PreviewShell_overlayHidden__1416a";
var _6 = "PreviewShell_pdf__6ce94";
var _7 = "PreviewShell_shell__de238";
var _8 = "PreviewShell_wrapper__43216";
var _9 = "PreviewShell_zeroLineHeight__2b21e";
export { _1 as "disableClicks", _2 as "highlighter", _3 as "noClick", _4 as "overlay", _5 as "overlayHidden", _6 as "pdf", _7 as "shell", _8 as "wrapper", _9 as "zeroLineHeight" }
